<template>
  <div class="customeStats" style="padding: 10px; overflow: auto; width: 100%; height: 100%;">
    <a-form-model v-show="isTableShow" layout="inline" style="margin-bottom: 15px;">
      <a-form-model-item :label="$t('runningData.machineCode')">
        <a-input style="width: 170px" allow-clear :placeholder="$t('runningData.machineCode')" v-model="searchForm.machineCode" />
      </a-form-model-item>
      <a-form-model-item :label="$t('runningData.model')">
        <a-input style="width: 170px" allow-clear :placeholder="$t('runningData.model')" v-model="searchForm.model" />
      </a-form-model-item>
      <a-form-model-item :label="$t('runningData.company')">
        <a-input style="width: 170px" allow-clear :placeholder="$t('runningData.company')" v-model="searchForm.company" />
      </a-form-model-item>
      <a-form-model-item :label="$t('runningData.area')">
        <a-input style="width: 170px" allow-clear :placeholder="$t('runningData.area')" v-model="searchForm.address" />
      </a-form-model-item>
      <a-form-model-item :label="$t('runningData.start')">
        <a-month-picker style="width: 170px" v-model="searchForm.startMonth" format="YYYY-MM" />
      </a-form-model-item>
      <a-form-model-item :label="$t('runningData.end')" style="margin-right: 0;">
        <a-month-picker style="width: 170px" v-model="searchForm.endMonth" format="YYYY-MM" />
      </a-form-model-item>
      <a-form-model-item style="float: right; margin-right: 0;">
        <a-button v-if="authorities.find(a => a.code === 'device:manage:device:running:data:query')" type="primary" html-type="submit" @click="getStats">
          {{ $t('buttons.search') }}
        </a-button>
        <a-button v-if="authorities.find(a => a.code === 'device:manage:device:running:data:export')" :loading="loadingBtn" type="primary" @click="exportStats" style="margin-left: 15px;">
          {{ $t('buttons.export') }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <h2 class="tableTitle" v-show="isTableShow">{{ year }}{{ $t('runningData.title') }}</h2>
    <el-table v-show="isTableShow" v-loading="loading" :data="data" border style="width: 100%" stripe>
      <!-- <el-table-column label="2023年平均使用数据" align="center" label-class-name="title"> -->
      <el-table-column prop="code" :label="$t('runningData.machineCode')" width="150" />
      <el-table-column prop="company" :label="$t('runningData.company')" width="200" />
      <el-table-column prop="address" :label="$t('runningData.area')" width="200" />
      <el-table-column prop="model" :label="$t('runningData.model')" />
      <el-table-column prop="type" :label="$t('runningData.type')" width="180" />
      <el-table-column prop="power" :label="$t('runningData.pr')" :width="lang === 'en' ? '140' : '70'" />
      <el-table-column v-for="(i, index) in monthColumns" :key="i" :label="i" align="center">
        <el-table-column v-for="item in dataTypes" :key="item.id" :prop="`stats[${index}].${item.id}`" :label="item.label"
          :width="item.width">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button type="text" size="small">编辑</el-button> -->
            <div :style="{ color: countColor(scope.row.stats, item.id, index) }">
              {{ scope.row.stats[index][item.id] }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('common.operation')" :width="lang === 'en' ? '123' : '102'" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="drawCharts(scope.row)">{{ $t('device.analysis') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination v-show="isTableShow" :current="pagination.current" :total="pagination.total"
      style="float: right; margin: 15px 0 5px 0;" @change="handlePageChange" />
    <div class="charts_container" v-show="!isTableShow">
      <header>
        <ul class="typeofcharts">
          <li :class="{ activeType: activeChartsType === 'line' }" @click="setChartsType('line')">{{ $t('line') }}</li>
          <li :class="{ activeType: activeChartsType === 'bar' }" @click="setChartsType('bar')">{{ $t('bar') }}</li>
        </ul>
        <div class="info">
          <span>{{ $t('runningData.machineCode')}}: {{ record.code }}</span>
          <span>{{ $t('runningData.company')}}: {{ record.company }}</span>
          <span>{{ $t('runningData.area')}}: {{ record.address }}</span>
          <span>{{ $t('runningData.model')}}: {{ record.model }}</span>
        </div>
        <a-tooltip>
          <template slot="title">
            {{ $t('buttons.goBack') }}
          </template>
          <a-icon type="arrow-left" class="icon" @click="closeCharts" />
        </a-tooltip>
      </header>
      <hr/>
      <ul>
        <li v-for="item in dataTypes" :key="item.id">
          <h3 class="title">{{ item.label }}</h3>
          <hr/>
          <!-- <div class="chart" :id="item.id"></div> -->
          <div class="chart_wrapper">
            <div class="chart" :id="item.id"></div>
            <div class="value">
              <p>{{ $t('min') }}: {{ item.max }}</p>
              <p>{{ $t('max') }}: {{ item.min }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const colors = ["#4F72CB", '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00']
import moment from 'moment'
import exportDataApi from '@/api/export-data'
import { mapGetters } from 'vuex'
import { getRunningData, exportRunningData } from '@/api/device'

export default {
  data() {
    return {
      monthColumns: [],
      dataTypes: [
        {
          id: 'avgElectric',
          label: `${this.$t('runningData.electricity')}(A)`,
          max: '0.00',
          min: 'Infinity',
          width: 110
        },
        {
          id: 'avgTemperature',
          label: `${this.$t('runningData.temperature')}(℃)`,
          max: '0.00',
          min: 'Infinity',
          width: 130
        },
        {
          id: 'avgPressure',
          label: `${this.$t('runningData.pressure')}(MPa)`,
          // width: 90,
          max: '0.00',
          min: 'Infinity',
          width: 130
        },
        {
          id: 'avgRate',
          label: `${this.$t('runningData.frequency')}(Hz)`,
          max: '0.00',
          min: 'Infinity',
          width: 120
        },
        {
          id: 'avgPower',
          label: `${this.$t('runningData.power')}(kW)`,
          // width: 90,
          max: '0.00',
          min: 'Infinity',
          width: 100
        },
        {
          id: 'runTime',
          label: `${this.$t('runningData.runTime')}(h)`,
          // width: 110,
          max: '0.00',
          min: 'Infinity',
          width: 140
        }
      ],
      data: [],
      record: {
        code: '',
        company: '',
        address: '',
        model: '',
        stats: []
      },
      searchForm: {
        machineCode: '',
        model: '',
        company: '',
        address: '',
        startMonth: '',
        endMonth: ''
      },
      isTableShow: true,
      moment,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      loadingBtn: false,
      activeChartsType: 'line',
      authorities: []
    }
  },
  watch: {
    dark(value) {
      let color = value ? '#fff' : '#000'
      for (let i = 0; i < this.dataTypes.length; i++) {
        const { id } = this.dataTypes[i]
        this.options[id].series[0].label.color = color
        this.charts[id].setOption(this.options[id])
      }
    }
  },
  computed: {
    year() {
      if (this.monthColumns.length === 0) {
        return new Date().getFullYear()+ this.$t('runningData.year')
      } else {
        if (this.monthColumns[0].slice(0, 4) === this.monthColumns.at(-1).slice(0, 4)) {
          return this.monthColumns[0].slice(0, 4)+ this.$t('runningData.year')
        } else {
          return this.monthColumns[0].slice(0, 4)+ this.$t('runningData.year') + ' - ' + this.monthColumns.at(-1).slice(0, 4)+ this.$t('runningData.year')
        }
      }
    },
    ...mapGetters(['dark']),
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(v) {
      this.validateAndSetMonthRange()
      if (v === 'en') {
        this.dataTypes = [
          {
            id: 'avgElectric',
            label: `${this.$t('runningData.electricity')}(A)`,
            max: '0.00',
            min: 'Infinity',
            width: 110
          },
          {
            id: 'avgTemperature',
            label: `${this.$t('runningData.temperature')}(℃)`,
            max: '0.00',
            min: 'Infinity',
            width: 130
          },
          {
            id: 'avgPressure',
            label: `${this.$t('runningData.pressure')}(MPa)`,
            // width: 90,
            max: '0.00',
            min: 'Infinity',
            width: 130
          },
          {
            id: 'avgRate',
            label: `${this.$t('runningData.frequency')}(Hz)`,
            max: '0.00',
            min: 'Infinity',
            width: 120
          },
          {
            id: 'avgPower',
            label: `${this.$t('runningData.power')}(kW)`,
            // width: 90,
            max: '0.00',
            min: 'Infinity',
            width: 100
          },
          {
            id: 'runTime',
            label: `${this.$t('runningData.runTime')}(h)`,
            // width: 110,
            max: '0.00',
            min: 'Infinity',
            width: 140
          }
        ]
      } else {
        this.dataTypes = [
          {
            id: 'avgElectric',
            label: `${this.$t('runningData.electricity')}(A)`,
            max: '0.00',
            min: 'Infinity'
          },
          {
            id: 'avgTemperature',
            label: `${this.$t('runningData.temperature')}(℃)`,
            max: '0.00',
            min: 'Infinity'
          },
          {
            id: 'avgPressure',
            label: `${this.$t('runningData.pressure')}(MPa)`,
            width: 90,
            max: '0.00',
            min: 'Infinity'
          },
          {
            id: 'avgRate',
            label: `${this.$t('runningData.frequency')}(Hz)`,
            max: '0.00',
            min: 'Infinity'
          },
          {
            id: 'avgPower',
            label: `${this.$t('runningData.power')}(kW)`,
            width: 90,
            max: '0.00',
            min: 'Infinity'
          },
          {
            id: 'runTime',
            label: `${this.$t('runningData.runTime')}(h)`,
            width: 110,
            max: '0.00',
            min: 'Infinity'
          }
        ]
      }
      for (let id in this.charts) {
        this.options[id].xAxis.data = this.monthColumns
        this.charts[id].setOption(this.options[id], { replaceMerge: ['xAxis'] })
      }
      !this.isTableShow && this.drawCharts(this.record)
    }
  },
  created() {
    this.searchForm.startMonth = moment(new Date(new Date().getFullYear() + ''), 'YYYY-MM')
    this.searchForm.endMonth = moment(new Date(), 'YYYY-MM')
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  mounted() {
    this.getStats()
  },
  beforeDestroy() {
    for (let i = 0; i < this.dataTypes.length; i++) {
      const { id } = this.dataTypes[i]
      this.charts?.[id]?.dispose()
    }
  },
  methods: {
    getStats(e) {
      if (+this.searchForm.startMonth._d > +this.searchForm.endMonth._d) {
        return this.$message.warn(this.lang === 'en' ? 'The start time is later than the end time. Select the correct time' : '起始时间晚于结束时间，请选择正确的时间')
      }
      if (!this.validateAndSetMonthRange()) {
        return
      }
      if (e) {
        this.pagination.current = 1
      }
      const searchForm = {
        ...this.searchForm,
        machineCode: this.searchForm.machineCode.split('-').join(''),
        startMonth: this.searchForm.startMonth.format('YYYY-MM'),
        endMonth: this.searchForm.endMonth.format('YYYY-MM'),
        ...this.pagination
      }
      delete searchForm.total
      this.loading = true
      console.log(searchForm);
      getRunningData(searchForm).then(({ data }) => {
        this.pagination.current = data.current
        this.pagination.pageSize = data.size
        this.pagination.total = data.total
        this.data = data.records
      }).catch(() => { }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getStats()
    },
    exportStats() {
      if (+this.searchForm.startMonth._d > +this.searchForm.endMonth._d) {
        return this.$message.warn(this.lang === 'en' ? 'The start time is later than the end time. Select the correct time' : '起始时间晚于结束时间，请选择正确的时间')
      }
      if (!this.validateAndSetMonthRange()) {
        return
      }
      const q = {
        ...this.searchForm,
        startMonth: this.searchForm.startMonth.format('YYYY-MM'),
        endMonth: this.searchForm.endMonth.format('YYYY-MM'),
      }
      delete q.current
      delete q.pageSize
      this.loadingBtn = true
      exportRunningData(q).then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
        console.log(url);
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const name = `${this.year} 客户使用数据报表`
        link.download = name + '.xlsx'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success(this.$t('messages.es'), 1)
      }).catch((e) => { console.log(e); }).finally(() => {
        this.loadingBtn = false
      })
    },
    countColor(item, type, index) {
      if (index === 0) return ''
      if (item[index][type] < item[index - 1][type]) {
        return 'green'
      }
      if (item[index][type] > item[index - 1][type]) {
        return 'red'
      }
    },
    validateAndSetMonthRange() {
      const s = this.searchForm.startMonth.format('YYYY-MM')
      const e = this.searchForm.endMonth.format('YYYY-MM')
      const ss = s.split('-')
      const es = e.split('-')
      const monthColumns = []
      for (let i = +ss[0]; i <= +es[0]; i++) {
        if (i === +ss[0]) {
          const endTag = ss[0] === es[0] ? +es[1] + 1 : 13
          for (let j = +ss[1]; j < endTag; j++) {
            let m = j
            if (this.lang === 'en') {
              m = m < 10 ? '0' + m : m
            }
            monthColumns.push(i+ this.$t('runningData.year') + m + this.$t('runningData.month'))
          }
        } else if (i === +es[0]) {
          for (let j = 1; j <= +es[1]; j++) {
            let m = j
            if (this.lang === 'en') {
              m = m < 10 ? '0' + m : m
            }
            monthColumns.push(i+ this.$t('runningData.year') + m + this.$t('runningData.month'))
          }
        } else {
          for (let j = 1; j < 13; j++) {
            let m = j
            if (this.lang === 'en') {
              m = m < 10 ? '0' + m : m
            }
            monthColumns.push(i+ this.$t('runningData.year') + m + this.$t('runningData.month'))
          }
        }
      }
      if (monthColumns.length > 13) {
        this.$message.warn(this.lang === 'en' ? 'The time frame cannot exceed one year' : '时间范围不能超过一年')
        return false
      }
      this.monthColumns = monthColumns
      return true
    },
    drawCharts(row) {
      this.charts = {}
      this.options = {}
      this.record = row
      this.isTableShow = false
      this.$nextTick(() => {
        for (let i = 0; i < this.dataTypes.length; i++) {
          const { id, label } = this.dataTypes[i]
          if (!this.charts[id]) {
            this.charts[id] = this.$echarts.init(
              document.getElementById(id),
              null,
              {
                renderer: "canvas",
                useDirtyRect: false
              }
            )
          }
          this.options[id] = {
            tooltip: {
              trigger: 'axis',
              formatter: params => {
                let dataStr = `<div><p style="margin:0 8px 15px;">${params[0].axisValueLabel}</p></div>`
                dataStr += `<div>
                  <div style="margin: 0 8px;">
                    ${params[0].marker}
                    <span>${params[0].seriesName}</span>
                    <span style="float:right;color:#666;margin-left:20px;font-weight:550">${(+params[0].data).toFixed(2)}</span>
                  </div>
                </div>`
                return dataStr
              }
            },
            grid: {
              top: "22%",
              bottom: "-1%",
              left: '1%',
              right: '1%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: this.monthColumns
            },
            yAxis: {
              type: 'value',
              splitLine: {
                show: false
              }
            },
            series: [
              {
                name: label,
                type: this.activeChartsType,
                label: {
                  show: true,
                  position: 'top',
                  formatter: param => {
                    return (+param.data).toFixed(2)
                  }
                },
                lineStyle: {
                  color: colors[i]
                },
                itemStyle: {
                  color: colors[i]
                },
                tooltip: {
                  show: true
                }
              }
            ]
          }
          this.options[id].series[0].data = row.stats.map(item => {
            this.dataTypes[i].max = Math.max(+this.dataTypes[i].max, item[id]).toFixed(2)
            this.dataTypes[i].min = Math.min(+this.dataTypes[i].min, item[id]).toFixed(2)

            return item[id] || '0.001'
          })
          this.charts[id].group = 'group'
          this.$echarts.connect('group')
          this.charts[id].setOption(this.options[id])
        }
      })
    },
    setChartsType(type) {
      if (this.activeChartsType === type) {
        return
      }
      this.activeChartsType = type
      for (let i = 0; i < this.dataTypes.length; i++) {
        const { id } = this.dataTypes[i]
        this.options[id].series[0].type = type
        this.charts[id].setOption(this.options[id])
        this.charts[id].resize()
      }
    },
    closeCharts() {
      this.record = {
        code: '',
        company: '',
        address: '',
        model: '',
        stats: []
      }
      this.isTableShow = true
      for (let i = 0; i < this.dataTypes.length; i++) {
        this.charts[this.dataTypes[i].id].dispose()
        this.dataTypes[i].max = '0.00'
        this.dataTypes[i].min = 'Infinity'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.customeStats .cell.title {
  color: #333;
  font-size: 16px;
}

.customeStats .tableTitle {
  background-color: #F5F7FA;
  text-align: center;
  margin-bottom: 0;
  border: 1px solid #EBEEF5;
  border-bottom: 0;
  padding: 10px 0;
}

.customeStats /deep/td.el-table__cell:nth-of-type(6n + 12):not(:last-child),
.customeStats /deep/th.el-table__cell:nth-of-type(6n),
.customeStats /deep/th.is-center.el-table__cell {
  border-right-width: 8px;
}

.customeStats .is-center.el-table__cell:last-child,
.customeStats /deep/th.el-table__cell[rowspan="2"] {
  border-right-width: 1px;
}

.charts_container {
  width: 100%;
  height: 100%;
  position: relative;
  header {
    width: 100%;
    height: 30px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    font-size: 16px;
    .info {
      span {
        margin: 15px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .gray {
      color: #888;
      cursor: pointer;
      &:hover {
        color: #1890ff;
      }
    }
    .black {
      color: #000;
      cursor: text;
    }
    .icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
  ul:not(.typeofcharts) {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      width: 100%;
      height: 20%;
      .title {
        height: 20px;
        line-height: 30px;
        padding-left: 5px;
        font-weight: 700;
        font-size: 18px;
        margin: 0;
        margin-bottom: 15px;
      }

      .chart_wrapper {
        width: 100%;
        height: calc(100% - 40px);
        display: flex;
        .chart {
          width: 90%;
          height: 100%;
        }
        .value {
          width: 10%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 16px;
        }
      }
    }
  }
}
.typeofcharts {
  display: flex;
  margin: 0;
  padding: 0;
}
.typeofcharts li {
  list-style: none;
  color: #a5abb3;
  font-size: 16px;
  cursor: pointer;
  &:nth-child(2) {
    margin-left: 10px;
  }
}
.typeofcharts li.activeType {
  color: #2199e9;
}

</style>